import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  buttonText: {
    marginLeft: Theme.px(10),
    marginRight: Theme.px(10),
    textAlign: 'center',
  },
});
